import {
  AfterViewInit,
  Component, createNgModule,
  Injector,
  ViewChild,
  ViewContainerRef
} from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  @ViewChild("windows", {read: ViewContainerRef})
  windows!: ViewContainerRef;


  constructor(
    private injector: Injector) {

  }

  async loadWindows() {
    const {WindowsModule} = await import("@account/windows/windows.module");
    const moduleRef = createNgModule(WindowsModule, this.injector);
    const lazyComponent = moduleRef.instance.getWindowComponent();
    this.windows.createComponent(lazyComponent, {ngModuleRef: moduleRef});
  }

  ngAfterViewInit(): void {
    this.loadWindows().then();
  }

}
